var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "#FFF4F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93555 4.08984V10.4961H9.00781V4.08984H9.93555ZM10.1992 11.8926V12.6445H4.21289V9.89062H5.15039V11.8926H10.1992ZM5.86328 5.4375C5.85352 6.7168 6.67383 7.88867 8.02148 8.35742L7.54297 9.09961C6.53223 8.72363 5.78516 7.98145 5.39453 7.0293C5.00879 8.04492 4.25195 8.86035 3.22656 9.25586L2.72852 8.52344C4.10547 8.01562 4.91602 6.75586 4.91602 5.4375V4.56836H5.86328V5.4375ZM18.2168 4.61719V5.25195C18.2168 6.02832 18.2168 7.01953 17.9824 8.41602H19.3008V9.17773H17.2598V12.8203H16.3418V9.17773H14.2422V12.8203H13.3145V9.17773H11.3223V8.41602H17.0449C17.3037 7.09766 17.3184 6.12598 17.3184 5.37891H12.3184V4.61719H18.2168Z",
    fill: "#F14840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBadge);
export default __webpack_public_path__ + "static/media/new-badge.6a32c24c88d9348a4437ebb2e51f380a.svg";
export { ForwardRef as ReactComponent };